webpackJsonp([13691680623043770000],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"presets\":[\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-es2015/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-stage-1/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-react/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-env/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-preset-react/lib/index.js\"],\"plugins\":[\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/tsuyoshiwada/develop/react-drip-form/www/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/examples/nest-fields.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  & form .rdf-group {\n    margin-top: 1em;\n    margin-bottom: 1em;\n  }\n\n  & form > div > div:not(.rdf-input) {\n    padding-left: 2em;\n  }\n\n  & form .members > div {\n    margin-top: 1em;\n    margin-bottom: 1em;\n  }\n\n  & form .input-group {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  & form .input-group > div {\n    width: 100%;\n  }\n\n  & form .input-group input {\n    border-top-right-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n  }\n\n  & form .input-group > button {\n    height: 2.7rem;\n    border-left: 0 !important;\n    border-top-left-radius: 0 !important;\n    border-bottom-left-radius: 0 !important;\n  }\n'], ['\n  & form .rdf-group {\n    margin-top: 1em;\n    margin-bottom: 1em;\n  }\n\n  & form > div > div:not(.rdf-input) {\n    padding-left: 2em;\n  }\n\n  & form .members > div {\n    margin-top: 1em;\n    margin-bottom: 1em;\n  }\n\n  & form .input-group {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  & form .input-group > div {\n    width: 100%;\n  }\n\n  & form .input-group input {\n    border-top-right-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n  }\n\n  & form .input-group > button {\n    height: 2.7rem;\n    border-left: 0 !important;\n    border-top-left-radius: 0 !important;\n    border-bottom-left-radius: 0 !important;\n  }\n']);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactDripFormComponents = __webpack_require__("./node_modules/react-drip-form-components/lib/index.js");
	
	var _src = __webpack_require__("../src/index.js");
	
	var _components = __webpack_require__("./src/components/index.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable no-alert */
	/* eslint-disable no-template-curly-in-string */
	
	
	var NestFieldsForm = (0, _src.dripForm)({
	  validations: {
	    'teams.*.name': {
	      required: true,
	      max: 30
	    },
	    'teams.*.members.*': {
	      max: 30
	    }
	  }
	})(function (_ref) {
	  var handlers = _ref.handlers,
	      fields = _ref.fields,
	      _ref$meta = _ref.meta,
	      invalid = _ref$meta.invalid,
	      pristine = _ref$meta.pristine;
	  return _react2.default.createElement(
	    'form',
	    { onSubmit: handlers.onSubmit },
	    fields.map('teams.*', function (teamName, teamIndex) {
	      return _react2.default.createElement(
	        'div',
	        { key: teamName },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: teamName },
	          'Team name #',
	          teamIndex + 1
	        ),
	        _react2.default.createElement(_reactDripFormComponents.Input, {
	          type: 'text',
	          name: teamName + '.name',
	          label: 'Team name'
	        }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactDripFormComponents.FieldGroup,
	            { name: teamName + '.scope' },
	            _react2.default.createElement(
	              _reactDripFormComponents.Radio,
	              { value: 'private' },
	              'Private'
	            ),
	            _react2.default.createElement(
	              _reactDripFormComponents.Radio,
	              { value: 'public' },
	              'Public'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'members' },
	            fields.map(teamName + '.members.*', function (memberName) {
	              return _react2.default.createElement(
	                'div',
	                { key: memberName },
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  'Member name'
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group' },
	                  _react2.default.createElement(_reactDripFormComponents.Input, {
	                    type: 'text',
	                    name: memberName,
	                    label: 'Member name'
	                  }),
	                  _react2.default.createElement(
	                    _components.Button,
	                    {
	                      small: true,
	                      type: 'button',
	                      onClick: function onClick() {
	                        return fields.remove(memberName);
	                      }
	                    },
	                    'Delete'
	                  )
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(
	            _components.Button,
	            {
	              small: true,
	              type: 'button',
	              onClick: function onClick() {
	                return fields.push(teamName + '.members', '');
	              }
	            },
	            'Add member'
	          ),
	          ' ',
	          _react2.default.createElement(
	            _components.Button,
	            {
	              small: true,
	              type: 'button',
	              onClick: function onClick() {
	                return fields.remove(teamName);
	              }
	            },
	            'Delete'
	          )
	        )
	      );
	    }),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _components.Button,
	        {
	          type: 'button',
	          onClick: function onClick() {
	            return fields.push('teams', {
	              name: '',
	              scope: 'private',
	              members: []
	            });
	          }
	        },
	        'Add team'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _components.Button,
	        {
	          primary: true,
	          onClick: handlers.onSubmit,
	          disabled: invalid || pristine
	        },
	        'Send message'
	      )
	    )
	  );
	});
	
	var Content = _styledComponents2.default.div(_templateObject);
	
	var NestFieldsFormExample = function (_Component) {
	  _inherits(NestFieldsFormExample, _Component);
	
	  function NestFieldsFormExample() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NestFieldsFormExample);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = NestFieldsFormExample.__proto__ || Object.getPrototypeOf(NestFieldsFormExample)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	      values: {
	        teams: [{ name: 'Initial Team', scope: 'private', members: [] }]
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(NestFieldsFormExample, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var location = this.props.location;
	      var values = this.state.values;
	
	
	      return _react2.default.createElement(
	        _components.Layout,
	        {
	          title: 'Nest Fields',
	          location: location
	        },
	        _react2.default.createElement(
	          'p',
	          null,
	          'This is an example of a nested Field form.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'The ',
	          _react2.default.createElement(
	            'code',
	            null,
	            'name'
	          ),
	          ' attribute of the nested Field must be expressed in dot notation.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Example: '
	          ),
	          _react2.default.createElement(
	            'code',
	            null,
	            'foo.bar'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Validation on objects in the array can be specified using a wildcard (',
	          _react2.default.createElement(
	            'code',
	            null,
	            '*'
	          ),
	          ')!',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Example: '
	          ),
	          _react2.default.createElement(
	            'code',
	            null,
	            'array.*.key'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'And, Dynamic data manipulation is possible by adding, deleting, or moving values using ',
	          _react2.default.createElement(
	            'code',
	            null,
	            'fields'
	          ),
	          '.'
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Example:'
	        ),
	        _react2.default.createElement(
	          Content,
	          null,
	          _react2.default.createElement(NestFieldsForm, {
	            values: values,
	            onChange: function onChange(v) {
	              return _this2.setState({ values: v });
	            },
	            onValidSubmit: function onValidSubmit(v) {
	              alert('See console');
	              console.log(v);
	            }
	          })
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Values:'
	        ),
	        _react2.default.createElement(
	          _components.Code,
	          { language: 'javascript' },
	          JSON.stringify(values, null, 2)
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Sample Code:'
	        ),
	        _react2.default.createElement(
	          _components.Code,
	          { language: 'javascript' },
	          'import React from \'react\';\nimport { dripForm } from \'react-drip-form\';\n\nconst NestFieldsForm = dripForm({\n  validations: {\n    \'teams.*.name\': {\n      required: true,\n      max: 30,\n    },\n    \'teams.*.members.*\': {\n      max: 30,\n    },\n  },\n})(({\n  handlers,\n  fields,\n  meta: { invalid, pristine },\n}) => (\n  <form onSubmit={handlers.onSubmit}>\n    {fields.map(\'teams.*\', (teamName, teamIndex) => (\n      <div key={teamName}>\n        <label htmlFor={teamName}>Team name #{teamIndex + 1}</label>\n        <Input\n          type="text"\n          name={`' + '${teamName}' + '.name`}\n          label="Team name"\n        />\n\n        <div>\n          <FieldGroup name={`' + '${teamName}' + '.scope`}>\n            <Radio value="private">Private</Radio>\n            <Radio value="public">Public</Radio>\n          </FieldGroup>\n\n          <div className="members">\n            {fields.map(`' + '${teamName}' + '.members.*`, memberName => (\n              <div key={memberName}>\n                <label>Member name</label>\n                <div className="input-group">\n                  <Input\n                    type="text"\n                    name={memberName}\n                    label="Member name"\n                  />\n                  <Button\n                    small\n                    type="button"\n                    onClick={() => fields.remove(memberName)}\n                  >\n                    Delete\n                  </Button>\n                </div>\n              </div>\n            ))}\n          </div>\n\n          <Button\n            small\n            type="button"\n            onClick={() => fields.push(`' + '${teamName}' + '.members`, \'\')}\n          >\n            Add member\n          </Button>\n          {\' \'}\n          <Button\n            small\n            type="button"\n            onClick={() => fields.remove(teamName)}\n          >\n            Delete\n          </Button>\n        </div>\n      </div>\n    ))}\n\n    <div>\n      <Button\n        type="button"\n        onClick={() => fields.push(\'teams\', {\n          name: \'\',\n          scope: \'private\',\n          members: [],\n        })}\n      >\n        Add team\n      </Button>\n    </div>\n\n    <div>\n      <Button\n        primary\n        onClick={handlers.onSubmit}\n        disabled={invalid || pristine}\n      >\n        Send message\n      </Button>\n    </div>\n  </form>\n));'
	        )
	      );
	    }
	  }]);
	
	  return NestFieldsFormExample;
	}(_react.Component);
	
	exports.default = NestFieldsFormExample;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-examples-nest-fields-js-6fd442f0b02201250c09.js